import type { Commune, Perimetre } from "models";
import { Endpoints } from "enums";
import { collectivitesApiClient } from "./apiClients";
import { sortingUtil } from "utils";

/**
 * Récupère toutes les communes et les retourne triées par nom
 * @returns Array<Commune>
 */
async function getAll(): Promise<Array<Commune>> {
  const url = Endpoints.COMMUNES;
  const data = await collectivitesApiClient.get<Array<Commune>, Array<Commune>>(url);
  return data
    .map<Commune>(({ id, libelle }) => ({ _type: "commune", id, libelle }))
    .sort(sortingUtil.sortCommunes);
}

/**
 * Récupère tous les périmètres d'une commune.
 * @param codeInsee Code INSEE de la commune
 * @returns Array<Perimetre>
 */
async function getAllPerimetresByCommune(codeInsee: string): Promise<Array<Perimetre>> {
  const url = `/${Endpoints.COMMUNES}/${codeInsee}/perimetres`;
  return collectivitesApiClient.get<Array<Perimetre>, Array<Perimetre>>(url);
}

export const communesService = {
  getAll,
  getAllPerimetresByCommune,
};
